import React from 'react';
import PreviewList from '../../PreviewList';
import { Spin, Upload } from 'antd';
import { RemoteUploaderProps } from './utils/types';
import './index.scss';

function RemoteUploader(props: RemoteUploaderProps) {
  const {
    fileListMap,
    fieldName,
    showUploading,
    type,
    max,
    uploadKey,
    showUploadList,
    actionUrl,
    onUploadChange,
    onBeforeUpload,
    onPreviewMedia,
    onDeletePreviewMediasList,
    onRemoveUploadedMedia,
    remoteUploadCustomRequest,
  } = props;

  const canUpload = !max || (fileListMap?.[fieldName]?.length ?? 0) < max;

  return (
    <div className="remote-upload-wrapper">
      {canUpload && (
        <Upload
          listType="picture-card"
          accept={type}
          maxCount={max}
          key={uploadKey}
          action={actionUrl}
          showUploadList={showUploadList}
          onChange={(data: any) => onUploadChange?.(data, fieldName)}
          beforeUpload={(file: any) =>
            onBeforeUpload ? onBeforeUpload(file, fieldName) : file
          }
          customRequest={(option: any) => {
            remoteUploadCustomRequest?.(option, fieldName);
          }}
          onPreview={onPreviewMedia}
          onRemove={(file: any) => onRemoveUploadedMedia?.(file, fieldName)}
        >
          +
        </Upload>
      )}
      {showUploading && <Spin tip="正在上传中......" />}
      <div className="remote-upload-preview-list">
        <PreviewList
          fill={true}
          fileList={fileListMap[fieldName] || []}
          onDelete={(file: any) => onDeletePreviewMediasList?.(file, fieldName)}
          onPreview={() => {}}
        />
      </div>
    </div>
  );
}

export default RemoteUploader;
